if (!customElements.get('free-shipping-progress-bar')) {
  class FreeShippingProgressBar extends HTMLElement {
    connectedCallback() {
      const total = Number(this.dataset.cartTotal);
      const threshold = Number(this.dataset.shippingAmount);
      if (!Number.isFinite(total) || !Number.isFinite(threshold) || threshold <= 0) {
        this.hidden = true;
        return;
      }
      const eligible = total >= threshold;
      const remaining = this.querySelector('.free-shipping__info-remaining');
      const eligibility = this.querySelector('.free-shipping__info-eligibility');
      if (remaining) remaining.hidden = eligible;
      if (eligibility) eligibility.hidden = !eligible;
      this.style.setProperty('--percent', Math.min(100, Math.max(0, total / threshold * 100)) + '%');
    }
  }
  customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
}
